import React, { PureComponent } from 'react'
import Request from '../../request'
import { Button, Col, Divider, Form, InputNumber, Row, Select, Steps, DatePicker, notification, Input } from 'antd'

import { connect } from 'react-redux'
import styles from './style.less'
import moment from 'moment'
import _ from 'lodash'
import async from 'async'
import typeOfDegree from '../../containers/Masters/typeOfDegree'
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const Option = Select.Option
const { MonthPicker } = DatePicker

@Form.create()
class Qualification extends PureComponent {
    state = {
        qualification: null,
        passingYear: null,
        percentage: null,
        cgpa10: null,
        gpa4: null,
        gpa5: null,
        letterGrade: null,
        maths: null,
        english: null,
        stream: [],
        major: null,
        backlogs: null,
        degreeType: null,
        university: null,
        board: null,
        current: 0,
        from: null,
        to: null,
        allUniversity: [],
        allBoard: [],
        gradingSystem: '',
        gradingSystemScores: [],
        score: null,
        qualificationStatus: null,
        qualificationPassingYears: [],
        typeOfDegree: null,
        countriesData: [],
        studyCountry: 'India',
        primaryInstructionLanguage: null
    }


    updateScores = async (score) => {
        let checkData = {
            "Percentage": 'percentage',
            "CGPA 10.0 Scale": "cgpa10",
            "GPA 4.0 Scale": 'gpa4',
            "GPA 5.0 Scale": 'gpa5',
            "Letter Grade": 'letterGrade'
        }
        let testData = {}
        let fieldName = checkData[this.state.gradingSystem]
        testData[fieldName] = Number(score)
        let response = await Request.getQualificationScore(testData);
        if (response && response.success) {
            let { data } = response
            this.setState({ score, percentage: data.percentage, cgpa10: data.cgpa10, gpa5: data.gpa5, gpa4: data.gpa4, letterGrade: data.letterGrade })
        } else {
            this.setState({ score })
        }



    }

    // #region Submit
    onSubmit = () => {
        let y = []
        let x = this.state

        if (!x.studyCountry && !this.props.hide) {
            notification.error({
                message: 'Choose Country of Study'
            })
            return
        }

        if (x.qualification != "X" && !x.primaryInstructionLanguage && !this.props.hide) {
            notification.error({
                message: 'Choose Primary Language of Instruction'
            })
            return
        }

        if (!x.qualificationStatus) {
            notification.error({
                message: 'Choose Qualification Status'
            })
            return
        }
        if (!x.from && !this.props.hide) {
            notification.error({
                message: 'Choose From'
            })
            return
        }
        if (x.qualificationStatus === "Completed" && !x.to && !this.props.hide) {
            notification.error({
                message: 'Choose To'
            })
            return
        }
        if (x.qualification != "X" && !x.stream.length) {
            notification.error({
                message: 'Choose Stream'
            })
            return
        }
        if (x.gradingSystem == "") {
            notification.error({
                message: 'Choose Grading System'
            })
            return
        }
        if (x.qualificationStatus === "Completed" && !x.score) {
            notification.error({
                message: 'Enter Score'
            })
            return
        }
        if (!x.board && !this.props.hide && (x.qualification === "X" || x.qualification === "XII")) {
            notification.error({
                message: 'Choose Board'
            })
            return
        }
        if (!x.degreeType && !this.props.hide && x.qualification !== "X" && x.qualification !== "XII") {
            notification.error({
                message: 'Choose Type of Degree'
            })
            return
        }
        if (!x.university && !this.props.hide && x.qualification != "X" && x.qualification != "XII") {
            notification.error({
                message: 'Choose University'
            })
            return
        }

        y.push({
            studyCountry: x.studyCountry,
            qualification: x.qualification,
            passingYear: x.passingYear,
            stream: x.stream,
            maths: x.maths,
            english: x.english,
            major: x.major,
            from: moment(x.from).format('MM-YYYY'),
            to: moment(x.to).format('MM-YYYY'),
            backlogs: x.backlogs,
            degreeType: x.degreeType,
            university: x.university,
            board: x.board,
            gradingSystem: x.gradingSystem,
            score: x.score,
            qualificationStatus: x.qualificationStatus,
            percentage: x.percentage,
            cgpa10: x.cgpa10,
            gpa4: x.gpa4,
            gpa5: x.gpa5,
            letterGrade: x.letterGrade,
            primaryInstructionLanguage: x.primaryInstructionLanguage
        })

        this.props.handleSubmit(y)

        this.setState({
            primaryInstructionLanguage: null,
            studyCountry: null,
            passingYear: null,
            stream: [],
            percentage: null,
            cgpa10: null,
            gpa4: null,
            gpa5: null,
            letterGrade: null,
            maths: null,
            english: null,
            major: [],
            backlogs: null,
            degreeType: null,
            from: null,
            to: null,
            score: null,
            qualificationStatus: null,
            gradingSystem: null,
            board: null,
            qualification: null
        })
    }

    changeQualificationStatus(qualificationStatus) {
        let qualificationPassingYears = []
        if (qualificationStatus === "Completed") {
            for (let i = 0; i <= 50; i++) {
                let year = new Date().getFullYear() - i
                qualificationPassingYears.push({ key: `${year}`, display: `${year}` })
                this.setState({ qualificationPassingYears })
            }
        } else if (qualificationStatus === "Pursuing") {
            for (let i = 0; i <= 10; i++) {
                let year = new Date().getFullYear() + i
                qualificationPassingYears.push({ key: `${year}`, display: `${year}` })
                this.setState({ qualificationPassingYears })
            }
        }
    }

    changeScoreOptions(gradingSystem) {
        let scores = []
        if (gradingSystem === "Percentage") {
            for (let i = 30; i <= 100; i++) {
                scores.push({ key: `${i}`, display: `${i}` })
            }
            this.setState({ gradingSystemScores: scores })
        } else if (gradingSystem === "CGPA 10.0 Scale") {
            for (let i = 0; i < 10; i++) {
                for (let d = 0; d < 10; d++) {
                    scores.push({ key: `${i}.${d}`, display: `${i}.${d}` })
                }
            }
            scores.push({ key: `10`, display: `10`, })
            this.setState({ gradingSystemScores: scores })
        } else if (gradingSystem === "GPA 4.0 Scale") {
            scores.push({ key: "1", display: "1" }, { key: "1.3", display: "1.3" }, { key: "1.7", display: "1.7" }, { key: "2", display: "2" },
                { key: "2.3", display: "2.3" }, { key: "2.5", display: "2.5" }, { key: "2.7", display: "2.7" }, { key: "2.75", display: "2.75" }, { key: "2.8", display: "2.8" }, { key: "3", display: "3" }, { key: "3.1", display: "3.1" },
                { key: "3.2", display: "3.2" }, { key: "3.3", display: "3.3" }, { key: "3.4", display: "3.4" }, { key: "3.5", display: "3.5" }, { key: "3.6", display: "3.6" },
                { key: "3.7", display: "3.7" }, { key: "3.8", display: "3.8" }, { key: "3.9", display: "3.9" }, { key: "4", display: "4" })
            this.setState({ gradingSystemScores: scores })
        } else if (gradingSystem === "Letter Grade") {
            scores.push({ key: "A+", display: "A+" }, { key: "A", display: "A" }, { key: "A-", display: "A-" }, { key: "B+", display: "B+" }, { key: "B", display: "B" }, { key: "B-", display: "B-" },
                { key: "C+", display: "C+" }, { key: "C", display: "C" }, { key: "C-", display: "C-" }, { key: "D+", display: "D+" }, { key: "D", display: "D" })
            this.setState({ gradingSystemScores: scores })
        } else if (gradingSystem === "IB Grade") {
            scores.push({ key: "3", display: "3" }, { key: "4", display: "4" }, { key: "5", display: "5" }, { key: "6", display: "6" }, { key: "7", display: "7" })
            this.setState({ gradingSystemScores: scores })
        }
    }


    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    return temp
                }, [])

                this.setState({ countriesData: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }


    loadDegrees = async () => {
        let params = {
            sortField: "degreeName",
            sortOrder: "ascend",
            deleted: false,
            results: 10000,
            count: 10000
        }
        let response = await Request.getAllTypeOfDegrees(params);
        let typeOfDegree = {
            Diploma: [],
            'Bachelor Degree': [],
            masters: []
        }
        async.each(response.data, (item) => {
            if (item.qualification === "Bachelor Degree") {
                typeOfDegree["Bachelor Degree"].push({ key: item.degreeName, value: item.degreeName })
            } else if (item.qualification === "Diploma") {
                typeOfDegree["Diploma"].push({ key: item.degreeName, value: item.degreeName })
            } else if (item.qualification === "Masters" || item.qualification === "Master Degree") {
                typeOfDegree["masters"].push({ key: item.degreeName, value: item.degreeName })
            }
        })
        this.setState({ typeOfDegree })
    }

    componentDidMount() {
        this.loadDegrees()
        this.loadCountries()
        Request.loadBoards({
            results: 10000,
        }).then((res) => {
            let universities = []
            let boards = []
            res.data.map((val, index) => {
                if (val.type == "University") {
                    universities.push(val)
                } else if (
                    val.type == "Board"
                ) {
                    boards.push(val)
                }
            })
            this.setState({ allUniversity: universities, allBoard: boards })
        })
    }

    render() {
        const { hide } = this.props
        let { qualification, typeOfDegree, countriesData } = this.state

        return (
            <div>
                <Row style={{ marginBottom: 10 }}>
                    {!hide ?
                        <Col span={4} style={{ marginRight: 5 }}>
                            <label className={styles.test}>Country of Study<small style={{ color: 'red' }}>*</small></label>
                            <Select
                                showSearch={true}
                                showAction={['focus', 'click']}
                                defaultValue={this.state.studyCountry}
                                onChange={studyCountry => {
                                    this.setState({
                                        studyCountry,
                                        passingYear: '',
                                        maths: '',
                                        english: '',
                                        percentage: '',
                                        degreeType: '',
                                        major: [],
                                        stream: [],
                                        backlogs: '',
                                        university: '',
                                        board: ''
                                    })
                                }}
                            >
                                {
                                    countriesData.map((country) => (
                                        <Option value={country.display}>{country.display}</Option>
                                    ))
                                }

                            </Select>
                        </Col>
                        : null
                    }
                    <Col span={4}>
                        <label className={styles.test}>Qualification<small style={{ color: 'red' }}>*</small></label>
                        <Select
                            showSearch={true}
                            showAction={['focus', 'click']}
                            onChange={qualification => {
                                this.setState({
                                    qualification,
                                    passingYear: '',
                                    maths: '',
                                    english: '',
                                    percentage: '',
                                    degreeType: '',
                                    major: [],
                                    stream: [],
                                    backlogs: '',
                                    university: '',
                                    board: ''
                                })
                            }}>
                            <Option value={'X'}>X</Option>
                            <Option value={'XII'}>XII</Option>
                            <Option value={'Diploma'}>Diploma</Option>
                            <Option value={'Bachelor Degree'}>Bachelor Degree</Option>
                            <Option value={'Post Graduation'}>Master Degree</Option>
                        </Select>
                    </Col>
                    {qualification ? (
                        <Col span={4} style={{ marginLeft: 10 }}>
                            <label className={styles.test}>Qualification Status<small style={{ color: 'red' }}>*</small></label>
                            <Select value={this.state.qualificationStatus} onChange={qualificationStatus => {
                                this.setState({ qualificationStatus })
                                this.changeQualificationStatus(qualificationStatus)
                            }}>
                                <Option value={'Completed'}>Completed</Option>
                                <Option value={'Pursuing'}>Pursuing</Option>
                            </Select>

                        </Col>
                    ) : null}
                </Row>

                {qualification ? (
                    <div className={'qualItem'}>
                        {
                            !hide ?
                                <div>
                                    <label className={styles.test}>{`From [YYYY-MM]`}<small style={{ color: 'red', width: '50px' }}>*</small></label>
                                    <MonthPicker value={this.state.from} onChange={from => {
                                        this.setState({ from })
                                    }} />
                                </div> : null
                        }
                        {
                            !hide ?
                                <div>
                                    <label className={styles.test}>{`To [YYYY-MM]`}<small style={{ color: 'red' }}>*</small></label>
                                    <MonthPicker value={this.state.to} onChange={to => {
                                        this.setState({ to })
                                    }} />
                                </div> : null
                        }
                        {/* {
                            !hide ? <div>
                                <label className={styles.test}>Passing year</label>
                                <Select showSearch={true} value={this.state.passingYear} onChange={passingYear=>{
                                    this.setState({passingYear})
                                }}>
                                    {this.state.qualificationPassingYears.map((item)=>(
                                        <Option value={item.key}>{item.display}</Option>
                                    ))}
                                </Select>
                            </div> : null
                        } */}

                        {qualification !== 'X' ? (
                            <React.Fragment>
                                <div>
                                    <label className={styles.test}>Streams<small style={{ color: 'red' }}>*</small></label>
                                    <Select
                                        value={this.state.stream}
                                        required={true}
                                        showSearch={true}
                                        dropdownMatchSelectWidth={false}
                                        // mode={'multiple'}
                                        onChange={streams => {
                                            this.setState({ stream: streams })
                                        }}>
                                        <Option value={'MEDICAL'}>MEDICAL</Option>
                                        <Option value={'NON-MEDICAL'}>NON-MEDICAL</Option>
                                        <Option value={'COMMERCE'}>COMMERCE</Option>
                                        <Option value={'ARTS'}>ARTS</Option>
                                    </Select>
                                </div>
                                {!this.props.hide ?
                                    <div>
                                        <label className={styles.test}>Primary Language Of Instruction <small style={{ color: 'red' }}>*</small></label>
                                        <Input onChange={v => this.setState({ primaryInstructionLanguage: v.target.value })} />
                                    </div>
                                    : null}
                            </React.Fragment>
                        ) : null}
                        {qualification === "X" || qualification === "XII" ? (
                            <React.Fragment>
                                <div>
                                    <label className={styles.test}>Grading System<small style={{ color: 'red' }}>*</small></label>
                                    <Select value={this.state.gradingSystem} showSearch={true}
                                        onChange={gradingSystem => {
                                            this.setState({ gradingSystem })
                                            this.changeScoreOptions(gradingSystem)
                                        }}>
                                        <Option value={'Percentage'}>Percentage</Option>
                                        <Option value={'CGPA 10.0 Scale'}>CGPA 10.0 Scale</Option>
                                        <Option value={'GPA 4.0 Scale'}>GPA 4.0 Scale</Option>
                                        <Option value={'Letter Grade'}>Letter Grade</Option>
                                        <Option value={'IB Grade'}>IB Grade</Option>

                                    </Select>
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div>
                                    <label className={styles.test}>Grading System<small style={{ color: 'red' }}>*</small></label>
                                    <Select value={this.state.gradingSystem} showSearch={true}
                                        onChange={gradingSystem => {
                                            this.setState({ gradingSystem })
                                            this.changeScoreOptions(gradingSystem)
                                        }}>
                                        <Option value={'Percentage'}>Percentage</Option>
                                        <Option value={'CGPA 10.0 Scale'}>CGPA 10.0 Scale</Option>
                                        <Option value={'GPA 4.0 Scale'}>GPA 4.0 Scale</Option>
                                    </Select>
                                </div>
                            </React.Fragment>
                        )}
                        <div>
                            <label className={styles.test}>Score<small style={{ color: 'red' }}>*</small></label>
                            <Select value={this.state.score} showSearch={true} onChange={(score) => {
                                this.updateScores(score)

                            }}>
                                {this.state.gradingSystemScores.map((item) => (
                                    <Option value={item.key}>{item.display}</Option>
                                ))}
                            </Select>
                        </div>
                        {qualification === 'X' || qualification === 'XII' ? (
                            <React.Fragment>
                                <div>
                                    <label className={styles.test}>Math Score<small style={{ color: 'red' }}>*</small></label>
                                    <InputNumber
                                        value={this.state.maths}
                                        maxLength={4}
                                        allowClear
                                        className={'inputNumber inputNumberNew'}
                                        onChange={py => {

                                            this.setState({ maths: py })
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.test}>English Score<small style={{ color: 'red' }}>*</small></label>
                                    <InputNumber
                                        value={this.state.english}
                                        allowClear
                                        maxLength={4}
                                        className={'inputNumber inputNumberNew'}
                                        onChange={py => {

                                            this.setState({ english: py })
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className={styles.test}>Board<small style={{ color: 'red' }}>*</small></label>{' '}
                                    <Select
                                        showSearch={true}
                                        value={this.state.board}
                                        showAction={['focus', 'click']}
                                        dropdownMatchSelectWidth={false}
                                        onChange={BoardType => {
                                            this.setState({ board: BoardType })
                                        }}>
                                        {

                                            this.state.allBoard.map((val, index) => {
                                                return (
                                                    <Option key={index} value={val.boardName}>{val.boardName}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </div>
                            </React.Fragment>
                        ) : null}


                        {qualification !== 'X' ? (
                            <React.Fragment>
                                {
                                    !hide ? <div>
                                        <label className={styles.test}>Major Subjects<small style={{ color: 'red' }}>*</small></label>
                                        <Select
                                            mode="tags"
                                            style={{ width: '100%' }}
                                            placeholder="Tags Mode"
                                            value={this.state.major}
                                            onChange={ss => {
                                                this.setState({ major: ss })
                                            }}
                                        />
                                    </div> : null
                                }


                                {qualification !== 'XII' && qualification === 'Diploma' ? (
                                    <React.Fragment>
                                        <div>
                                            <label className={styles.test}>Backlogs</label>
                                            <InputNumber
                                                value={this.state.backlogs}
                                                allowClear
                                                className={'inputNumber inputNumberNew'}
                                                onChange={py => {
                                                    this.setState({ backlogs: py })
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label className={styles.test}>Type Of Degree<small style={{ color: 'red' }}>*</small></label>{' '}
                                            {
                                                this.state.studyCountry === "India" ?
                                                    <Select
                                                        showSearch={true}
                                                        value={this.state.degreeType}
                                                        showAction={['focus', 'click']}
                                                        dropdownMatchSelectWidth={false}
                                                        onChange={degreeType => {
                                                            this.setState({ degreeType })
                                                        }}>
                                                        {typeOfDegree.Diploma.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.value}>
                                                                    {val.value}
                                                                </Option>
                                                            )
                                                        })}
                                                    </Select>
                                                    :
                                                    <Input onChange={v => this.setState({ degreeType: v.target.value })} />
                                            }
                                        </div>
                                        <div>
                                            <label className={styles.test}>University<small style={{ color: 'red' }}>*</small></label>{' '}
                                            {this.state.studyCountry === "India" ?
                                                <Select
                                                    showSearch={true}
                                                    value={this.state.university}
                                                    showAction={['focus', 'click']}
                                                    dropdownMatchSelectWidth={false}
                                                    onChange={universityType => {
                                                        this.setState({ university: universityType })
                                                    }}>
                                                    {

                                                        this.state.allUniversity.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.boardName}>{val.boardName}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                                :
                                                <Input onChange={v => this.setState({ university: v.target.value })} />
                                            }
                                        </div>
                                    </React.Fragment>
                                ) : null}
                                {qualification !== 'XII' &&
                                    qualification === 'Bachelor Degree' ? (
                                    <React.Fragment>
                                        <div>
                                            <label className={styles.test}>Backlogs</label>
                                            <InputNumber
                                                value={this.state.backlogs}
                                                allowClear
                                                className={'inputNumber inputNumberNew'}
                                                onChange={py => {

                                                    this.setState({ backlogs: py })
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label>Type Of Degree<small style={{ color: 'red' }}>*</small></label>
                                            {
                                                this.state.studyCountry === "India" ?

                                                    <Select
                                                        showSearch={true}
                                                        value={this.state.degreeType}
                                                        showAction={['focus', 'click']}
                                                        dropdownMatchSelectWidth={false}
                                                        onChange={degreeType => {
                                                            this.setState({ degreeType })
                                                        }}>
                                                        {typeOfDegree['Bachelor Degree'].map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.value}>
                                                                    {val.value}
                                                                </Option>
                                                            )
                                                        })}
                                                    </Select>
                                                    :
                                                    <Input onChange={v => this.setState({ degreeType: v.target.value })} />
                                            }
                                        </div>
                                        <div>
                                            <label className={styles.test}>University<small style={{ color: 'red' }}>*</small></label>{' '}
                                            {this.state.studyCountry === "India" ?
                                                <Select
                                                    showSearch={true}
                                                    value={this.state.university}
                                                    showAction={['focus', 'click']}
                                                    dropdownMatchSelectWidth={false}
                                                    onChange={universityType => {
                                                        this.setState({ university: universityType })
                                                    }}>
                                                    {

                                                        this.state.allUniversity.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.boardName}>{val.boardName}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                                :
                                                <Input onChange={v => { this.setState({ university: v.target.value }) }} />
                                            }
                                        </div>
                                    </React.Fragment>
                                ) : null}
                                {qualification !== 'XII' &&
                                    qualification === 'Post Graduation' ? (
                                    <React.Fragment>
                                        <div>
                                            <label className={styles.test}>Backlogs</label>
                                            <InputNumber
                                                value={this.state.backlogs}
                                                allowClear
                                                className={'inputNumber inputNumberNew'}
                                                onChange={py => {

                                                    this.setState({ backlogs: py })
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label className={styles.test}>Type Of Degree<small style={{ color: 'red' }}>*</small></label>
                                            {
                                                this.state.studyCountry === "India" ?

                                                    <Select
                                                        showSearch={true}
                                                        value={this.state.degreeType}
                                                        dropdownMatchSelectWidth={false}
                                                        showAction={['focus', 'click']}

                                                        onChange={degreeType => {
                                                            this.setState({ degreeType: degreeType })
                                                        }}>
                                                        {typeOfDegree.masters.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.value}>
                                                                    {val.value}
                                                                </Option>
                                                            )
                                                        })}
                                                    </Select>
                                                    :
                                                    <Input onChange={v => this.setState({ degreeType: v.target.value })} />
                                            }
                                        </div>
                                        <div>
                                            <label className={styles.test}>University<small style={{ color: 'red' }}>*</small></label>{' '}
                                            {this.state.studyCountry === "India" ?
                                                <Select
                                                    showSearch={true}
                                                    value={this.state.university}
                                                    showAction={['focus', 'click']}
                                                    dropdownMatchSelectWidth={false}
                                                    onChange={universityType => {
                                                        this.setState({ university: universityType })
                                                    }}>
                                                    {

                                                        this.state.allUniversity.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val.boardName}>{val.boardName}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                                :
                                                <Input onChange={v => this.setState({ university: v.target.value })} />
                                            }
                                        </div>
                                    </React.Fragment>
                                ) : null}
                            </React.Fragment>
                        ) : null}

                        <div>
                            <Button
                                style={{
                                    marginBottom: '9px',
                                    marginTop: '17px',
                                    height: '30px'
                                }}
                                size={'small'}
                                type="primary"
                                onClick={this.onSubmit}> ADD </Button>

                        </div>

                    </div>

                ) : null}


                <Divider />

            </div>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Qualification)
